import { render, staticRenderFns } from "./PhrCodeUpdatePopUp.vue?vue&type=template&id=79283055&scoped=true&"
import script from "./PhrCodeUpdatePopUp.vue?vue&type=script&lang=js&"
export * from "./PhrCodeUpdatePopUp.vue?vue&type=script&lang=js&"
import style0 from "./PhrCodeUpdatePopUp.vue?vue&type=style&index=0&id=79283055&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79283055",
  null
  
)

export default component.exports